const CmnBtnContainer = () => {
  return (
        <div id="btn-wrapper">
            <button className="outline">
                Talk to Sales
            </button>
            <button className="standard">
                Get Started
            </button>
        </div>
  )
}

export default CmnBtnContainer
